import GuestRoute from './GuestRoute';

export default GuestRoute;
